module.exports = __webpack_public_path__ + "static/img/overstock.7e076673.jpg";